export default __webpack_public_path__ + "static/media/rpl10.b0720271.jpg";